module.exports = __webpack_public_path__ + "img/synopsis_005.1224a96e.png";